type TrackTab = "details" | "rights" | "credits" | "lyrics" | "contracts";

const buildTrackTabs = (trackId: number, activeTab: TrackTab) => [
  {
    label: "Details",
    href: `/tracks/${trackId}`,
    active: activeTab === "details",
  },
  {
    label: "Rights",
    href: `/tracks/${trackId}/rights`,
    active: activeTab === "rights",
  },
  {
    label: "Credits",
    href: `/tracks/${trackId}/credits`,
    active: activeTab === "credits",
  },
  {
    label: "Lyrics",
    href: `/tracks/${trackId}/lyrics`,
    active: activeTab === "lyrics",
  },
  {
    label: "Contracts",
    href: `/tracks/${trackId}/contracts`,
    active: activeTab === "contracts",
  },
];

export default buildTrackTabs;
